import { render } from "./MorePerks00.vue?vue&type=template&id=0e64344c&scoped=true"
const script = {}

import "./MorePerks00.vue?vue&type=style&index=0&id=0e64344c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e64344c"]])

export default __exports__